import { z } from "zod";
import { oc } from "@orpc/contract";
//#region src/api/orpc/imageFilter.ts
const applyImageFilterInputSchema = z.object({
	sourceMediaId: z.string().min(1, "sourceMediaId is required"),
	resultMediaId: z.string().min(1, "resultMediaId is required"),
	filterId: z.string().min(1, "filterId is required"),
	strength: z.number().min(0).max(1).default(1)
});
const applyImageFilterOutputSchema = z.object({
	taskId: z.string(),
	mediaId: z.string()
});
const imageFilterContract = oc.prefix("/image-filter").tag("ImageFilter").router({ applyFilter: oc.route({
	summary: "Save filtered image result as a completed generation task",
	method: "POST",
	path: "/apply"
}).input(applyImageFilterInputSchema).output(applyImageFilterOutputSchema).errors({
	UNAUTHORIZED: {
		status: 401,
		message: "User not authenticated"
	},
	MEDIA_NOT_FOUND: {
		status: 404,
		message: "Media not found"
	},
	FILTER_NOT_FOUND: {
		status: 404,
		message: "Filter not found"
	},
	INVALID_MEDIA_TYPE: {
		status: 400,
		message: "Media must be an image"
	}
}) });
//#endregion
export { applyImageFilterInputSchema, applyImageFilterOutputSchema, imageFilterContract };
